import React, { useState, Context, ReactElement, Component } from "react";
import { user_subscription } from "./user-subscriptions";

export interface IUserInfoType {
  address: string;
  alternative_email: string;
  avatar: string;
  city: string;
  code?: number;
  company: string;
  contact_phone: string;
  country: string;
  creation_time: number;
  creator: string;
  expiration_time: number;
  first_name: string;
  groups: string[];
  id: string;
  industry: string;
  lastCity: string;
  lastIp: string;
  lastLat: number;
  lastLong: number;
  lastModifiedPwdTime: number;
  lastModifiedTime: number;
  lastName: string;
  lastSignedInTime: number;
  mobilePhone: string;
  officePhone: string;
  origin: string;
  postalCode: string;
  role: string;
  roles: any[];
  salt: string;
  signedInFrequencyCounter: number;
  status: string;
  userName: string;
  userSubscriptions: user_subscription[];
  watchOnly: boolean;
  ssoRole: string;
  ssoSubscriptions: user_subscription[];

  subscription_id: string;
  is_globaladmin: number;
  is_datacenteradmin: number;
  is_clusteradmin: number;
  is_clusterowner: number;
  is_workspaceowner: number;
  is_namespacedeveloper: number;
  // has_namespacedeveloper: number;
  wkOwner_has_namespacedeveloper: string[];   //同一个订阅号同一个集群,数组里面是集群

  is_mp_lite: number;
}

const UserInfoContext: Context<[IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>]> = React.createContext<
  [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>]
>([([] as unknown) as IUserInfoType, (_value: any) => {}]);

const UserInfoProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [user_info, set_user_info]: [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>] = useState(({} as unknown) as IUserInfoType);
  return <UserInfoContext.Provider value={[user_info, set_user_info]}>{props.children}</UserInfoContext.Provider>;
};

export { UserInfoContext, UserInfoProvider };
